import type { FC } from "react";

const TestesPage: FC = () => {
    return (
        <div className="bg-white flex flex-col gap-16 w-full h-screen p-24 overflow-auto"></div>
    );
};

export default TestesPage;
